<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3>{{ label.get("profile_password") }}</h3>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get("user_profile") }}</label>
            <!--<i class="atto info-icon"
               id="tooltip-user-profile"></i>
            <b-tooltip
                target="tooltip-user-profile"
                custom-class="info-tooltip"
                placement="bottom" >
              <label>{{ label.get('user_profile') }}</label>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
            </b-tooltip>-->
          </div>

          <button class="update-btn" @click="updateUserDetails">
            <i class="atto atto-edit-btn-sv" />
            {{ label.get("update_details") }}
          </button>
        </div>
        <div class="user-details">
          <div class="user-profile" :class="{ 'emailInput-open': newEmail }">
            <div class="profile-pic">
              <input
                ref="file"
                type="file"
                accept="image/*"
                hidden
                @change="uploadProfilePic($event)"
              />
              <img v-if="imageUrl" :src="imageUrl" width="100" height="100" />
              <span v-if="!imageUrl" class="initials">
                {{ initials }}
              </span>
              <div class="edit-overlay">
                <div v-if="!imageUrl" class="add" @click="$refs.file.click()">
                  <i class="atto-camera-icon" />
                  <p>Set profile <br />picture</p>
                </div>
                <div v-if="imageUrl" class="edit-pic">
                  <button class="change" @click="$refs.file.click()">
                    <i class="atto atto-edit-btn" />
                  </button>
                  <button
                    class="delete"
                    :disabled="disabledDeleteButton"
                    @click="deleteImage()"
                  >
                    <i class="atto atto-delete" />
                  </button>
                </div>
              </div>
            </div>
            <div class="user-info">
              <div class="name info-field">
                <h4 class="name">{{ name }}</h4>
              </div>
              <hr class="separator-line" />
              <div class="mail info-field">
                <span class="mail">{{ email }}</span>
              </div>
            </div>
            <div v-if="emailChangeRequest" class="changed-email">
              <div class="new-user-info">
                <span class="label">
                  {{ label.get("email_change_request_pending") }}</span
                >
                <div class="mail info-field">
                  <i class="atto atto-alert-triangle" />
                  <span class="mail">{{ emailChange }}</span>
                </div>
                <p class="error-message">
                  {{ label.get("message_we_sent_verification_email_to_you") }}
                </p>
                <div class="email-change-footer">
                  <button
                    type="submit"
                    class="atto-btn submit submit-form"
                    :disabled="disableResendVerificationEmail"
                    @click="resendVerificationEmail()"
                  >
                    {{
                      disableResendVerificationEmail
                        ? label.get("resending_email")
                        : label.get("resend_verification_email")
                    }}
                  </button>
                  <button
                    type="submit"
                    class="atto-btn cancel submit-form"
                    @click="cancelChangeRequest()"
                  >
                    {{ label.get("cancel_change_request") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <form
            v-if="showLicenseForm"
            class="details-form"
            @submit.prevent="saveLicenseNumberForm"
          >
            <div class="license-section">
              <h4 class="section-headtitle">
                License
              </h4>
              <div class="row">
                <div class="col">
                  <div class="form-row row-align">
                    <div class="col">
                      <label>License number</label>
                      <div
                        class="input-wrapper"
                        :class="{ 'has-error': $v.license_number.$error }"
                      >
                        <input
                          type="text"
                          placeholder="Add number"
                          name="license_number"
                          maxlength="50"
                          v-model="license_number"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-row submit-wrap">
                    <button type="submit" class="atto-btn submit submit-form">
                      Save License Number
                    </button>
                  </div>
                </div>
                <div class="col">
                  <div class="form-row row-align">
                    <div class="col">
                      <label>Upload your license</label>
                      <input
                        ref="license_file"
                        type="file"
                        accept="image/bmp, image/jpeg, image/jpg, image/png, application/pdf"
                        class="upload-license"
                        multiple
                        @change="uploadLicenseImages($event)"
                      />
                      <div class="atto-btn upload submit submit-form">
                        Upload License
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{
              label.get("change_password")
            }}</label>
            <!--  <i class="atto info-icon"
               id="tooltip-change-password"></i>
            <b-tooltip
                target="tooltip-change-password"
                custom-class="info-tooltip"
                placement="bottom" >
              <label>{{ label.get('change_password') }}</label>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
            </b-tooltip>-->
          </div>
        </div>
        <div class="user-details password-section">
          <form
            class="details-form"
            method="post"
            @submit.prevent="changePasswordForm"
          >
            <div class="form-row">
              <label>{{ label.get("old_password") }}</label>
              <div
                class="input-wrapper"
                :class="{ 'has-error': $v.old_password.$error }"
              >
                <input
                  v-model="old_password"
                  type="password"
                  :placeholder="label.get('type_old_password')"
                  name="old_password"
                  :class="{
                    valid: $v.old_password.$dirty && !$v.old_password.$invalid,
                  }"
                  @input="errors = false"
                />
                <i
                  v-if="old_password_confirmed"
                  class="atto atto-selected-tick tick"
                />
              </div>
            </div>
            <div class="form-row row-align">
              <div class="col new-pass">
                <label>{{ label.get("new_password") }}</label>
                <div
                  class="input-wrapper"
                  :class="{ 'has-error': $v.password.$error }"
                >
                  <input
                    v-model="password"
                    type="password"
                    :placeholder="label.get('type_new_password')"
                    name="password"
                    maxlength="50"
                    @input="errors = false"
                  />
                </div>
              </div>
              <div class="col">
                <label>{{ label.get("confirm_new_password") }}</label>
                <div
                  class="input-wrapper"
                  :class="{ 'has-error': $v.password_confirmation.$error }"
                >
                  <input
                    v-model="password_confirmation"
                    type="password"
                    name="password_confirmation"
                    :placeholder="label.get('retype_new_password')"
                    maxlength="50"
                    @input="errors = false"
                  />
                  <i
                    v-if="
                      password_confirmation &&
                        $v.password_confirmation.sameAsNewPassword
                    "
                    class="atto atto-selected-tick tick"
                  />
                </div>
              </div>
            </div>
            <div class="form-row submit-wrap">
              <button type="submit" class="atto-btn submit submit-form">
                {{ label.get("set_new_password") }}
              </button>
            </div>

            <div class="form-errors">
              <span
                v-if="
                  errors &&
                    (!$v.old_password.required ||
                      !$v.password.required ||
                      !$v.password_confirmation.required)
                "
                class="error-message"
                >{{
                  label.get("message_please_fill_in_all_required_fields")
                }}</span
              >
              <span
                v-if="errors && apiError.old_password"
                class="error-message"
                >{{ apiError.old_password }}</span
              >
              <span
                v-if="errors && !$v.password.minLength"
                class="error-message"
              >
                {{ label.choice("password_must_have_at_least", 0) }}
                {{ $v.password.$params.minLength.min }}
                {{ label.choice("password_must_have_at_least", 1) }}.
              </span>
              <span
                v-if="errors && !$v.password_confirmation.minLength"
                class="error-message"
              >
                {{ label.choice("password_must_have_at_least", 0) }}
                {{ $v.password_confirmation.$params.minLength.min }}
                {{ label.choice("password_must_have_at_least", 1) }}
              </span>
              <span
                v-if="errors && !$v.password_confirmation.sameAsNewPassword"
                class="error-message"
              >
                {{ label.get("confirmation_password_do_not_match") }}
              </span>
              <span v-if="errors && !$v.password.regex" class="error-message">
                {{
                  label.get("request_password_must_contain_at_least_one_letter")
                }}
              </span>
              <span v-if="modalErrorPasswordMessage" class="error-message">{{
                modalErrorPasswordMessage
              }}</span>
            </div>
          </form>
        </div>
      </div>
      <update-user-details-component v-if="showUpdateUserDetails" />
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  sameAs,
  email,
  helpers,
} from "vuelidate/lib/validators";
import UserService from "../services/UserService";
import UtilsService from "../../../shared/services/UtilsService";
import EmailChangeConfirmPasswordComponent from "./components/EmailChangeConfirmPasswordComponent";
import UpdateUserDetailsComponent from "./components/UpdateUserDetailsComponent";

export default {
  name: "ProfileComponent",
  components: {
    UpdateUserDetailsComponent,
    EmailChangeConfirmPasswordComponent,
  },
  data() {
    return {
      old_password: "",
      old_password_confirmed: false,
      password: "",
      password_confirmation: "",
      errors: false,
      apiError: {
        old_password: false,
        password: false,
        message: false,
      },
      nameEditMode: false,
      nameError: false,
      emailEditMode: false,
      emailChangeEditMode: false,
      showInputChangeEmail: false,
      showEmailChangeLabel: false,
      emailError: false,
      emailChange: this.$store.state.user.email_change,
      emailChangeRequest: this.$store.state.user.email_change_request,
      changeEmailPassword: "",
      modalErrorPasswordMessage: null,
      newEmail: false,
      editName: "",
      name: this.$store.state.user.name,
      initials: this.$store.state.user.initials,
      email: this.$store.state.user.email,
      originalEmail: this.$store.state.user.email,
      imageUrl: this.$store.state.user.avatar,
      showEmailChangeConfig: false,
      disableResendVerificationEmail: false,
      isChangeEmailChangeRequest: false,
      disabledDeleteButton: false,
      showLicenseForm: this.$store.state.userLicense.enabled,
      license_number: this.$store.state.userLicense.license,
      license_images: [],
      licenseErrors: false,
      showUpdateUserDetails: false,
    };
  },

  watch: {
    email: function(val) {
      if (this.emailEditMode) {
        this.newEmail = val !== this.originalEmail && val.length > 0;
      } else {
        this.newEmail = false;
      }
    },
    deep: true,
    old_password: function(val) {
      if (this.new_password === this.old_password) {
      }
    },
  },
  validations: {
    old_password: {
      required,
    },
    password: {
      required,
      minLength: minLength(8),
      regex: helpers.regex("alpha", /\w*[a-zA-Z]\w*/),
    },
    password_confirmation: {
      required,
      minLength: minLength(8),
      sameAsNewPassword: sameAs("password"),
    },
    email: {
      required,
      email,
    },
    emailChange: {
      required,
      email,
    },
    name: {
      required,
      maxLength: maxLength(50),
    },
    license_number: {
      required,
      maxLength: maxLength(50),
    },
  },
  mounted() {
    this.$root.$on("hideEmailChangeConfirm", this.hideEmailChangeConfirm);
    this.$root.$on("hideUserDetails", this.hideUserDetails);
  },
  methods: {
    updateUserDetails() {
      this.showUpdateUserDetails = true;
    },
    hideUserDetails(data) {
      this.showUpdateUserDetails = false;
      if (data !== undefined && data.name) {
        this.name = data.name;
      }

      if (data !== undefined && data.change_email_request) {
        this.isChangeEmailChangeRequest = data.change_email_request;
        this.emailChange = data.email;
        this.handleChangeEmail();
      }
    },

    changePasswordForm() {
      this.$v.old_password.$touch();
      this.$v.password.$touch();
      this.$v.password_confirmation.$touch();

      if (
        this.$v.old_password.$invalid ||
        this.$v.password.$invalid ||
        this.$v.password_confirmation.$invalid
      ) {
        this.errors = true;
        return false;
      }

      this.errors = false;
      let params = {
        old_password: this.old_password,
        password: this.password,
        password_confirmation: this.password_confirmation,
      };
      this.modalErrorPasswordMessage = null;
      UserService.changePassword(params)
        .then((response) => {
          this.$v.$reset();
          this.errors = false;
          this.apiError.old_password = false;
          this.old_password = "";
          this.password = "";
          this.password_confirmation = "";
          this.$awn.success(response.data.message);
        })
        .catch((error) => {
          this.modalErrorPasswordMessage = error.response.data.error.message;
        });
    },

    handleChangeEmail() {
      const _this = this;
      const params = {
        email: this.isChangeEmailChangeRequest ? this.emailChange : this.email,
      };
      this.$store.commit("showLoading");
      UserService.requestChangeEmail(params)
        .then((response) => {
          this.email = response.data.user.email;
          this.emailChangeRequest = response.data.user.email_change_request;
          this.emailChange = response.data.user.email_change;
          this.$store.state.user.email_change_request = this.emailChangeRequest;
          this.$store.state.user.email_change = this.emailChange;
          this.emailError = false;
          this.emailEditMode = false;
          this.emailChangeEditMode = false;
          this.showEmailChangeLabel = false;
          this.isChangeEmailChangeRequest = false;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          if (this.isChangeEmailChangeRequest) {
            this.emailChangeEditMode = true;
          } else {
            this.emailEditMode = true;
          }
          this.apiError.message = error.response.data.error.message;
          this.emailError = true;
          this.$store.commit("hideLoading");
          this.$nextTick(() => {
            if (_this.$refs.email !== undefined) {
              _this.$refs.email.focus();
            } else if (_this.$refs.emailChange !== undefined) {
              _this.$refs.emailChange.focus();
            }
          });
        });
    },

    resendVerificationEmail() {
      this.disableResendVerificationEmail = true;
      UserService.resendVerificationEmail()
        .then((result) => {
          this.$awn.success(result.message);
          this.disableResendVerificationEmail = false;
        })
        .catch((error) => {
          this.disableResendVerificationEmail = false;
        });
    },

    cancelChangeRequest() {
      this.$store.commit("showLoading");
      UserService.cancelChangeEmailRequest()
        .then((result) => {
          this.$store.commit("hideLoading");
          this.emailChangeRequest = false;
          this.$awn.success(result.message);
        })
        .catch(() => {
          this.$store.commit("hideLoading");
        });
    },

    uploadProfilePic(event) {
      const file = event.target.files[0];
      if (file === undefined || file === null) {
        return false;
      }
      if (!UtilsService.isValidImageFormat(file)) {
        this.$awn.alert(this.label.get("unsupported_file_format"));
        this.$refs.file.value = null;
        return false;
      }

      let data = new FormData();
      data.append("image", file);

      this.$store.commit("showLoading");
      UserService.uploadImage(data)
        .then((response) => {
          this.$store.commit("hideLoading");
          this.imageUrl = response.data.avatar;
          this.$awn.success(response.data.message);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteImage() {
      this.disabledDeleteButton = true;
      UserService.deleteImage()
        .then(() => {
          this.imageUrl = null;
          this.disabledDeleteButton = false;
        })
        .catch(() => {
          this.disabledDeleteButton = false;
        });
    },

    hideEmailChangeConfirm(success) {
      if (!success) {
        this.email = this.$store.state.user.email;
      } else {
        this.handleChangeEmail();
      }
      this.emailError = false;
      this.showEmailChangeConfig = false;
    },

    saveLicenseNumberForm() {
      const params = {
        license_number: this.license_number,
      };

      UserService.saveLicenseNumber(params)
        .then((response) => {
          this.$store.commit("hideLoading");
          this.$store.state.userLicense.license = this.license_number;
          this.$awn.success("Licenses number save successfully");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          console.log(error);
        });
    },

    uploadLicenseImages(event) {
      const _this = this;
      let validForm = false;

      const data = new FormData();
      $.each(event.target.files, function(key, file) {
        const size = Math.round(file.size / 1024); // size in Kb
        if (size < 10000) {
          if (file === undefined || file === null) {
            _this.validForm = false;
          }

          if (!UtilsService.isValidPdfOrImageFormat(file)) {
            _this.$awn.alert(this.label.get("unsupported_file_format"));
            _this.$refs.license_file.value = null;
            _this.validForm = false;
          }
          data.append(`license_images[${key}]`, file);
          _this.validForm = true;
        } else {
          _this.$awn.alert(
            "There is a 10MB file size limit. Please upload a smaller file."
          );
          _this.$refs.license_file.value = null;
          _this.validForm = false;
        }
      });

      if (!this.validForm) {
        return;
      }

      this.$store.commit("showLoading");
      UserService.uploadUserLicenseImages(data)
        .then((response) => {
          _this.$store.commit("hideLoading");
          _this.$refs.license_file.value = null;
          _this.$awn.success("Licenses Successfully uploaded");
        })
        .catch((error) => {
          _this.$refs.license_file.value = null;
          _this.$store.commit("hideLoading");
          _this.$awn.alert(error.error.message);
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.user-details {
  .user-profile {
    display: flex;
    flex-direction: row;
    padding: 30px 0 30px 40px;
    flex-wrap: wrap;

    .profile-pic {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 100px;
      max-width: 100px;
      height: 100px;
      margin-right: 40px;
      position: relative;

      > i {
        font-size: 119px;
        position: absolute;
        left: 0;
        top: 0;
      }

      .initials {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 1.5rem;
        line-height: 3rem;
        font-weight: 400;
        font-family: "Roboto", sans-serif;
        color: #999;
        background-color: #efefef;
        border-radius: 100%;
        width: 100%;
        height: 100%;
        text-transform: uppercase;
      }

      .edit-overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 100%;
        opacity: 0;

        .add {
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-top: 10px;
          -webkit-transition: ease all 0.15s;
          -moz-transition: ease all 0.15s;
          -ms-transition: ease all 0.15s;
          -o-transition: ease all 0.15s;
          transition: ease all 0.15s;
          transition-delay: 0.1s;
          cursor: pointer;

          i {
            width: 22px;
            height: 18px;
            background-image: url("~@assets/images/camera-icon.svg");
            -webkit-background-size: contain;
            background-size: contain;
            background-repeat: no-repeat;
            margin-bottom: 8px;
          }

          p {
            margin-bottom: 0;
            font-size: 0.75rem;
            line-height: 1.125rem;
            font-family: $roboto-font;
            font-weight: 500;
            color: #fff;
            text-align: center;
          }
        }

        .edit-pic {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 60px;

          .change {
            width: 24px;
            height: 24px;
            margin: 0;
            padding: 0;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            i {
              font-size: 16px;
              color: #fff;

              &:before {
                color: #fff;
              }
            }
          }

          .delete {
            width: 24px;
            height: 24px;
            margin: 0;
            padding: 0;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            i {
              font-size: 16px;
              color: #fff;
            }
          }
        }
      }

      img {
        border-radius: 100%;
      }

      &:hover {
        .edit-overlay {
          opacity: 1;

          .add {
            padding-top: 0;
          }
        }
      }
    }

    .user-info {
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      flex-grow: 1;
      max-width: calc(100% - 172px);

      .info-field {
        display: flex;
        flex-direction: row;
        min-width: 240px;
        margin-bottom: 0;
        align-items: center;
        flex-wrap: wrap;
        position: relative;

        h4.name {
          font-size: 1.25rem;
          line-height: 1.5rem;
          font-family: $roboto-font;
          font-weight: 500;
          color: $atto-font-color;
          margin-bottom: 0;
          max-width: calc(100% - 36px);
        }

        input {
          width: 320px;
          margin-left: -12px;
          border: 2px solid #efefef;
          padding: 0 10px;
          font-family: $roboto-font;
          line-height: 36px;
          color: $atto-font-color;

          &.name-input {
            font-size: 1.5rem;
            line-height: 36px;
            font-weight: 500;
          }

          &.email-input {
            font-size: 1rem;
            font-weight: 400;
          }

          &:focus {
            border-color: #00b9cb;
          }
        }

        span.mail {
          display: inline-flex;
          font-size: 1rem;
          line-height: 1.5rem;
          color: $atto-font-color;
          font-family: $roboto-font;
          font-weight: 400;
        }

        .change-alert {
          flex-grow: 2;
          width: 100%;
          display: inline-flex;
          font-size: 0.875rem;
          line-height: 1.25rem;
          font-family: $roboto-font;
          font-weight: 400;
          color: #e05656;
          max-width: 540px;
          margin-top: 6px;
        }

        &:last-child {
          margin-bottom: 0;
        }

        .error-wrapper {
          margin-right: 8px;
          margin-top: 0;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          top: 40px;

          .error-message {
            margin-top: 0;
          }

          .error-message:first-child {
            margin-top: 6px;
          }
        }
      }

      .error {
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        color: #e05656;
        top: calc(100% + 2rem);
        left: 0;
        margin-left: 0;
      }
      .separator-line {
        width: 40px;
        height: 2px;
        background-color: #efefef;
        margin: 16px 0 14px;
        border: 0;
      }
    }

    button.edit {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      margin-left: 12px;
      width: 24px;
      height: 24px;

      i {
        display: inline-flex;
        width: 24px;
        height: 24px;
        justify-content: center;
        align-items: center;

        &:before {
          font-size: 18px;
          color: $atto-dark-grey;
          @include base-transition(ease color 0.2s);
        }
      }

      &:hover {
        cursor: pointer;

        i {
          &:before {
            color: $atto-font-color;
          }
        }
      }
    }

    button.change {
      width: 100px;
      margin-left: 16px;
      font-size: 1rem;
      font-family: $roboto-font;
      font-weight: 400;
      color: #fff;
      text-transform: uppercase;
      display: inline-flex;
      justify-content: center;
    }

    .changed-email {
      flex-grow: 2;
      width: 100%;
      padding-left: 140px;
      margin-top: 30px;

      .info-field {
        margin: 8px 0;

        input {
          width: 320px;
          border: 2px solid #efefef;
          padding: 0 10px;
          font-family: $roboto-font;
          line-height: 36px;
          color: $atto-font-color;

          &:focus {
            border-color: #00b9cb;
          }
        }
      }

      .error-message {
        font: $roboto-regular 0.875rem/1.25rem $roboto-font;
        color: $atto-red;
        max-width: 455px;
        margin: 0 32px 40px;
      }

      span.label {
        color: $atto-not-active;
        font: $roboto-medium 0.625rem/0.6875rem $roboto-font;
        letter-spacing: 0.5px;
      }
      .mail {
        i.atto {
          margin-right: 8px;
        }
      }

      p.error {
        margin: 0 0 24px;
        max-width: 540px;
        font-weight: 400;
        font-size: 0.875rem;
        line-height: 1.25rem;
      }

      .change-mail-wrap {
        display: flex;
        flex-direction: row;
        align-items: center;

        span {
          position: relative;
          width: 320px;
          border: 2px solid #efefef;
          padding: 0 10px;
          font-family: $roboto-font;
          line-height: 36px;
          color: $atto-font-color;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        i {
          font-size: 14px;
          width: 24px;
          height: 24px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }

      .email-change-footer {
        display: flex;

        button {
          display: inline-flex;
          justify-content: center;
          width: 280px;
          max-width: 100%;
          margin-right: 40px;
          text-transform: uppercase;
          font-weight: 500;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    &.emailInput-open {
      padding-bottom: 86px;
    }
  }

  &.password-section {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 220px;

    .details-form {
      padding: 40px 0 60px;
      display: flex;
      flex-direction: column;
      max-width: 680px;
      justify-content: center;

      .form-row {
        display: flex;
        flex-direction: column;
        margin: 0;
        margin-bottom: 24px;

        .new-pass {
          .input-wrapper {
            margin-right: 40px;
          }
        }

        label {
          display: inline-flex;
          font-size: 0.625rem;
          line-height: 0.6875rem;
          font-family: $roboto-font;
          font-weight: 500;
          color: #666666;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          margin-bottom: 0.625rem;
        }

        .input-wrapper {
          display: flex;
          width: 320px;
          position: relative;
          flex-direction: row;
          padding: 10px 0 10px 12px;
          border: 2px solid #efefef;
          height: 40px;

          input {
            flex-grow: 1;
            border: 0;
            font-size: 0.875rem;
            line-height: 1.25rem;
            font-family: $roboto-font;
            font-weight: 400;
            color: $atto-font-color;
            @include style-placeholder(#999);
          }

          i.tick {
            width: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 10px;
          }

          &:focus-within {
            border-color: #00b9cb;
          }

          &.has-error {
            border-color: #e05656;
          }
        }

        .error-message {
          font-size: 0.875rem;
          line-height: 1.25rem;
          font-family: "Roboto", sans-serif;
          font-weight: 400;
          color: #e05656;
        }

        &.row-align {
          flex-direction: row;

          .col {
            padding: 0;
          }
        }

        &.submit-wrap {
          margin-top: 16px;
          margin-bottom: 0;
        }

        .submit-form {
          width: 320px;
          max-width: 100%;
          justify-content: center;
          text-transform: uppercase;
        }
      }

      .form-errors {
        .error-message {
        }
      }
    }
  }
}

.password-confirm {
  p {
    margin-bottom: 12px !important;
    text-align: left !important;
  }

  input {
    width: 100%;
    border: 2px solid #efefef;
    padding: 5px 10px;
    font-family: $roboto-font;
    line-height: 36px;
    color: $atto-font-color;

    &:focus {
      border-color: #00b9cb;
    }
  }
}

.license-section {
  padding-bottom: 40px;
  border-bottom: 2px solid #efefef;
  margin-bottom: 40px;

  .col {
    width: 50%;

    input.upload-license {
      width: 320px;
      max-width: 100%;
      position: absolute;
      left: 0;
      top: 34px;
      height: 40px;
      opacity: 0;
      cursor: pointer;
    }

    .upload {
      background-color: #262626;
    }
  }
}

@media (max-width: 1369px) {
  .user-details {
    &.password-section {
      .details-form {
        .form-row.row-align {
          flex-flow: column;

          .col.new-pass {
            margin-bottom: 24px;
          }
        }
      }
    }
  }
}
@media (max-width: 1265px) {
  .user-details.password-section {
    flex-flow: row !important;
  }
}
@media (max-width: 1200px) {
  .user-details {
    .user-profile {
      .changed-email {
        .error-message {
          max-width: 270px;
        }
        .email-change-footer {
          flex-flow: column;

          button.submit {
            margin: 0 0 25px;
          }
        }
      }
    }
  }
}
</style>
